var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNetwork2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 541.936,
    height: 524.729,
    viewBox: "0 0 541.936 524.729",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_23614",
    x: 61.276,
    y: 393.603,
    width: 457.453,
    height: 85.838,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#176b41",
    floodOpacity: 0.18
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14571",
    "data-name": "Group 14571",
    transform: "translate(-255.271 -6123.397)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14261",
    "data-name": "Group 14261",
    transform: "translate(718 6514.58)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2566",
    "data-name": "Ellipse 2566",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 10.131)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3296",
    "data-name": "Ellipse 3296",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -86.574)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2643",
    "data-name": "Ellipse 2643",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 10.131)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3322",
    "data-name": "Ellipse 3322",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -86.574)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2567",
    "data-name": "Ellipse 2567",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 75.523)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3336",
    "data-name": "Ellipse 3336",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -21.183)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2629",
    "data-name": "Ellipse 2629",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 75.523)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3337",
    "data-name": "Ellipse 3337",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -21.183)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2568",
    "data-name": "Ellipse 2568",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 10.131)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3282",
    "data-name": "Ellipse 3282",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -86.574)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2644",
    "data-name": "Ellipse 2644",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 10.131)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3310",
    "data-name": "Ellipse 3310",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -86.574)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2569",
    "data-name": "Ellipse 2569",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 75.523)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3338",
    "data-name": "Ellipse 3338",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -21.183)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2630",
    "data-name": "Ellipse 2630",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 75.523)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3339",
    "data-name": "Ellipse 3339",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -21.183)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2570",
    "data-name": "Ellipse 2570",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 10.131)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3283",
    "data-name": "Ellipse 3283",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -86.574)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2670",
    "data-name": "Ellipse 2670",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 10.131)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3305",
    "data-name": "Ellipse 3305",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -86.574)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2571",
    "data-name": "Ellipse 2571",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 75.523)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3340",
    "data-name": "Ellipse 3340",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -21.183)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2672",
    "data-name": "Ellipse 2672",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 75.523)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3341",
    "data-name": "Ellipse 3341",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -21.183)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2572",
    "data-name": "Ellipse 2572",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 10.131)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3284",
    "data-name": "Ellipse 3284",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -86.574)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2573",
    "data-name": "Ellipse 2573",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 75.523)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3342",
    "data-name": "Ellipse 3342",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -21.183)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2561",
    "data-name": "Ellipse 2561",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 10.131)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3280",
    "data-name": "Ellipse 3280",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -86.574)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2574",
    "data-name": "Ellipse 2574",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 75.523)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3343",
    "data-name": "Ellipse 3343",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -21.183)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2575",
    "data-name": "Ellipse 2575",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 21.183)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3297",
    "data-name": "Ellipse 3297",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -75.522)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2641",
    "data-name": "Ellipse 2641",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 21.183)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3323",
    "data-name": "Ellipse 3323",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -75.522)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2576",
    "data-name": "Ellipse 2576",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 86.575)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3344",
    "data-name": "Ellipse 3344",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -10.131)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2631",
    "data-name": "Ellipse 2631",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 86.575)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3345",
    "data-name": "Ellipse 3345",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -10.131)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2577",
    "data-name": "Ellipse 2577",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 21.183)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3285",
    "data-name": "Ellipse 3285",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -75.522)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2642",
    "data-name": "Ellipse 2642",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 21.183)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3311",
    "data-name": "Ellipse 3311",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -75.522)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2578",
    "data-name": "Ellipse 2578",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 86.575)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3346",
    "data-name": "Ellipse 3346",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -10.131)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2632",
    "data-name": "Ellipse 2632",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 86.575)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3347",
    "data-name": "Ellipse 3347",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -10.131)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2579",
    "data-name": "Ellipse 2579",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 21.183)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3286",
    "data-name": "Ellipse 3286",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -75.522)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2674",
    "data-name": "Ellipse 2674",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 21.183)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3306",
    "data-name": "Ellipse 3306",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -75.522)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2580",
    "data-name": "Ellipse 2580",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 86.575)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3348",
    "data-name": "Ellipse 3348",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -10.131)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2676",
    "data-name": "Ellipse 2676",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 86.575)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3349",
    "data-name": "Ellipse 3349",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -10.131)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2581",
    "data-name": "Ellipse 2581",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 21.183)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3287",
    "data-name": "Ellipse 3287",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -75.522)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2582",
    "data-name": "Ellipse 2582",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 86.575)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3350",
    "data-name": "Ellipse 3350",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -10.131)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2562",
    "data-name": "Ellipse 2562",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 21.183)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3288",
    "data-name": "Ellipse 3288",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -75.522)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2583",
    "data-name": "Ellipse 2583",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 86.575)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3351",
    "data-name": "Ellipse 3351",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -10.131)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2584",
    "data-name": "Ellipse 2584",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 32.235)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3298",
    "data-name": "Ellipse 3298",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -64.47)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2633",
    "data-name": "Ellipse 2633",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 32.235)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3324",
    "data-name": "Ellipse 3324",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -64.47)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2585",
    "data-name": "Ellipse 2585",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 97.627)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2623",
    "data-name": "Ellipse 2623",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 97.627)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2586",
    "data-name": "Ellipse 2586",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 32.235)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3289",
    "data-name": "Ellipse 3289",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -64.47)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2634",
    "data-name": "Ellipse 2634",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 32.235)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3312",
    "data-name": "Ellipse 3312",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -64.47)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2587",
    "data-name": "Ellipse 2587",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 97.627)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2624",
    "data-name": "Ellipse 2624",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 97.627)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2588",
    "data-name": "Ellipse 2588",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 32.235)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3290",
    "data-name": "Ellipse 3290",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -64.47)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2678",
    "data-name": "Ellipse 2678",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 32.235)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3307",
    "data-name": "Ellipse 3307",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -64.47)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2589",
    "data-name": "Ellipse 2589",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 97.627)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2680",
    "data-name": "Ellipse 2680",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 97.627)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2590",
    "data-name": "Ellipse 2590",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 32.235)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3291",
    "data-name": "Ellipse 3291",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -64.47)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2591",
    "data-name": "Ellipse 2591",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 97.627)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2563",
    "data-name": "Ellipse 2563",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 32.235)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3292",
    "data-name": "Ellipse 3292",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -64.47)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2592",
    "data-name": "Ellipse 2592",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 97.627)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2593",
    "data-name": "Ellipse 2593",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 42.366)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3299",
    "data-name": "Ellipse 3299",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -54.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2635",
    "data-name": "Ellipse 2635",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 42.366)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3325",
    "data-name": "Ellipse 3325",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -54.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2594",
    "data-name": "Ellipse 2594",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 107.758)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2625",
    "data-name": "Ellipse 2625",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 107.758)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2595",
    "data-name": "Ellipse 2595",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 42.366)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3300",
    "data-name": "Ellipse 3300",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -54.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2636",
    "data-name": "Ellipse 2636",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 42.366)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3313",
    "data-name": "Ellipse 3313",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -54.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2596",
    "data-name": "Ellipse 2596",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 107.758)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2626",
    "data-name": "Ellipse 2626",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 107.758)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2597",
    "data-name": "Ellipse 2597",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 42.366)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3301",
    "data-name": "Ellipse 3301",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -54.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2682",
    "data-name": "Ellipse 2682",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 42.366)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3308",
    "data-name": "Ellipse 3308",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -54.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2598",
    "data-name": "Ellipse 2598",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 107.758)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2684",
    "data-name": "Ellipse 2684",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 107.758)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2599",
    "data-name": "Ellipse 2599",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 42.366)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3302",
    "data-name": "Ellipse 3302",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -54.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2600",
    "data-name": "Ellipse 2600",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 107.758)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2564",
    "data-name": "Ellipse 2564",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 42.366)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3303",
    "data-name": "Ellipse 3303",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -54.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2601",
    "data-name": "Ellipse 2601",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 107.758)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2602",
    "data-name": "Ellipse 2602",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 53.418)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3314",
    "data-name": "Ellipse 3314",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -43.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2637",
    "data-name": "Ellipse 2637",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 53.418)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3326",
    "data-name": "Ellipse 3326",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -43.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2603",
    "data-name": "Ellipse 2603",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 118.81)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2621",
    "data-name": "Ellipse 2621",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 118.81)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2604",
    "data-name": "Ellipse 2604",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 53.418)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3315",
    "data-name": "Ellipse 3315",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -43.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2638",
    "data-name": "Ellipse 2638",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 53.418)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3316",
    "data-name": "Ellipse 3316",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -43.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2605",
    "data-name": "Ellipse 2605",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 118.81)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2627",
    "data-name": "Ellipse 2627",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 118.81)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2606",
    "data-name": "Ellipse 2606",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 53.418)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3317",
    "data-name": "Ellipse 3317",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -43.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2686",
    "data-name": "Ellipse 2686",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 53.418)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3318",
    "data-name": "Ellipse 3318",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -43.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2607",
    "data-name": "Ellipse 2607",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 118.81)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2688",
    "data-name": "Ellipse 2688",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 118.81)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2608",
    "data-name": "Ellipse 2608",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 53.418)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3319",
    "data-name": "Ellipse 3319",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -43.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2609",
    "data-name": "Ellipse 2609",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 118.81)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2565",
    "data-name": "Ellipse 2565",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 53.418)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3320",
    "data-name": "Ellipse 3320",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -43.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2610",
    "data-name": "Ellipse 2610",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 118.81)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2611",
    "data-name": "Ellipse 2611",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 64.47)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3327",
    "data-name": "Ellipse 3327",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -32.235)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2639",
    "data-name": "Ellipse 2639",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 64.47)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3328",
    "data-name": "Ellipse 3328",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -32.235)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2556",
    "data-name": "Ellipse 2556",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 0)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3304",
    "data-name": "Ellipse 3304",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -96.706)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2653",
    "data-name": "Ellipse 2653",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 0)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3329",
    "data-name": "Ellipse 3329",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -96.706)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2612",
    "data-name": "Ellipse 2612",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 129.862)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2622",
    "data-name": "Ellipse 2622",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 129.862)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2613",
    "data-name": "Ellipse 2613",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 64.47)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3330",
    "data-name": "Ellipse 3330",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -32.235)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2640",
    "data-name": "Ellipse 2640",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 64.47)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3331",
    "data-name": "Ellipse 3331",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -32.235)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2557",
    "data-name": "Ellipse 2557",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 0)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3293",
    "data-name": "Ellipse 3293",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -96.706)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2654",
    "data-name": "Ellipse 2654",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 0)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3321",
    "data-name": "Ellipse 3321",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -96.706)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2614",
    "data-name": "Ellipse 2614",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 129.862)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2628",
    "data-name": "Ellipse 2628",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 129.862)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2615",
    "data-name": "Ellipse 2615",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 64.47)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3332",
    "data-name": "Ellipse 3332",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -32.235)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2690",
    "data-name": "Ellipse 2690",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 64.47)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3333",
    "data-name": "Ellipse 3333",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -32.235)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2558",
    "data-name": "Ellipse 2558",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 0)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3294",
    "data-name": "Ellipse 3294",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -96.706)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2691",
    "data-name": "Ellipse 2691",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 0)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3309",
    "data-name": "Ellipse 3309",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -96.706)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2616",
    "data-name": "Ellipse 2616",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 129.862)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2692",
    "data-name": "Ellipse 2692",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 129.862)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2617",
    "data-name": "Ellipse 2617",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 64.47)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3334",
    "data-name": "Ellipse 3334",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -32.235)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2559",
    "data-name": "Ellipse 2559",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 0)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3295",
    "data-name": "Ellipse 3295",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -96.706)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2618",
    "data-name": "Ellipse 2618",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 129.862)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2619",
    "data-name": "Ellipse 2619",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 64.47)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3335",
    "data-name": "Ellipse 3335",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -32.235)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2560",
    "data-name": "Ellipse 2560",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 0)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3281",
    "data-name": "Ellipse 3281",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -96.706)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2620",
    "data-name": "Ellipse 2620",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 129.862)",
    fill: "#090909"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14506",
    "data-name": "Group 14506",
    transform: "translate(388.817 6123.397) rotate(90)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2567-2",
    "data-name": "Ellipse 2567",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 75.523)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2629-2",
    "data-name": "Ellipse 2629",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 75.523)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2569-2",
    "data-name": "Ellipse 2569",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 75.523)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2630-2",
    "data-name": "Ellipse 2630",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 75.523)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2571-2",
    "data-name": "Ellipse 2571",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 75.523)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2672-2",
    "data-name": "Ellipse 2672",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 75.523)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2573-2",
    "data-name": "Ellipse 2573",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 75.523)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2574-2",
    "data-name": "Ellipse 2574",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 75.523)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2576-2",
    "data-name": "Ellipse 2576",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 86.575)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2631-2",
    "data-name": "Ellipse 2631",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 86.575)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2578-2",
    "data-name": "Ellipse 2578",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 86.575)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2632-2",
    "data-name": "Ellipse 2632",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 86.575)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2580-2",
    "data-name": "Ellipse 2580",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 86.575)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2676-2",
    "data-name": "Ellipse 2676",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 86.575)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2582-2",
    "data-name": "Ellipse 2582",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 86.575)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2583-2",
    "data-name": "Ellipse 2583",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 86.575)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2585-2",
    "data-name": "Ellipse 2585",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 97.627)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2623-2",
    "data-name": "Ellipse 2623",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 97.627)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2587-2",
    "data-name": "Ellipse 2587",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 97.627)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2624-2",
    "data-name": "Ellipse 2624",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 97.627)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2589-2",
    "data-name": "Ellipse 2589",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 97.627)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2680-2",
    "data-name": "Ellipse 2680",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 97.627)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2591-2",
    "data-name": "Ellipse 2591",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 97.627)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2592-2",
    "data-name": "Ellipse 2592",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 97.627)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2594-2",
    "data-name": "Ellipse 2594",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 107.758)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2625-2",
    "data-name": "Ellipse 2625",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 107.758)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2596-2",
    "data-name": "Ellipse 2596",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 107.758)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2626-2",
    "data-name": "Ellipse 2626",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 107.758)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2598-2",
    "data-name": "Ellipse 2598",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 107.758)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2684-2",
    "data-name": "Ellipse 2684",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 107.758)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2600-2",
    "data-name": "Ellipse 2600",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 107.758)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2601-2",
    "data-name": "Ellipse 2601",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 107.758)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2602-2",
    "data-name": "Ellipse 2602",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 53.418)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2637-2",
    "data-name": "Ellipse 2637",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 53.418)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2603-2",
    "data-name": "Ellipse 2603",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 118.81)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2621-2",
    "data-name": "Ellipse 2621",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 118.81)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2604-2",
    "data-name": "Ellipse 2604",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 53.418)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2638-2",
    "data-name": "Ellipse 2638",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 53.418)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2605-2",
    "data-name": "Ellipse 2605",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 118.81)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2627-2",
    "data-name": "Ellipse 2627",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 118.81)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2606-2",
    "data-name": "Ellipse 2606",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 53.418)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2686-2",
    "data-name": "Ellipse 2686",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 53.418)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2607-2",
    "data-name": "Ellipse 2607",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 118.81)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2688-2",
    "data-name": "Ellipse 2688",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 118.81)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2608-2",
    "data-name": "Ellipse 2608",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 53.418)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2609-2",
    "data-name": "Ellipse 2609",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 118.81)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2565-2",
    "data-name": "Ellipse 2565",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 53.418)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2610-2",
    "data-name": "Ellipse 2610",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 118.81)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2611-2",
    "data-name": "Ellipse 2611",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 64.47)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2639-2",
    "data-name": "Ellipse 2639",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 64.47)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2612-2",
    "data-name": "Ellipse 2612",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 129.862)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2622-2",
    "data-name": "Ellipse 2622",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 129.862)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2613-2",
    "data-name": "Ellipse 2613",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 64.47)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2640-2",
    "data-name": "Ellipse 2640",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 64.47)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2614-2",
    "data-name": "Ellipse 2614",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 129.862)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2628-2",
    "data-name": "Ellipse 2628",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 129.862)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2615-2",
    "data-name": "Ellipse 2615",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 64.47)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2690-2",
    "data-name": "Ellipse 2690",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 64.47)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2616-2",
    "data-name": "Ellipse 2616",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 129.862)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2692-2",
    "data-name": "Ellipse 2692",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 129.862)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2617-2",
    "data-name": "Ellipse 2617",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 64.47)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2618-2",
    "data-name": "Ellipse 2618",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 129.862)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2619-2",
    "data-name": "Ellipse 2619",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 64.47)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2620-2",
    "data-name": "Ellipse 2620",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 129.862)",
    fill: "#090909"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2546",
    "data-name": "Rectangle 2546",
    transform: "translate(285 6156)",
    fill: "#fff",
    stroke: "#dae2d6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 462,
    height: 460,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 461,
    height: 459,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Recipient_details",
    "data-name": "Recipient details",
    transform: "translate(324 6215)",
    fill: "#111",
    fontSize: 24,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600,
    letterSpacing: "-0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Recipient details")), /*#__PURE__*/React.createElement("g", {
    id: "Group_7933",
    "data-name": "Group 7933",
    transform: "translate(324 6242)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2564",
    "data-name": "Rectangle 2564",
    transform: "translate(0 32)",
    fill: "#fff",
    stroke: "#dae2d6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 391,
    height: 50,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 390,
    height: 49,
    rx: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Account_holder_name_",
    "data-name": "Account holder name ",
    transform: "translate(0 17)",
    fill: "#111",
    fontSize: 15,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Account holder name ")), /*#__PURE__*/React.createElement("text", {
    id: "SM_Consulting_Pte._Ltd.",
    "data-name": "SM Consulting Pte. Ltd.",
    transform: "translate(17 62)",
    fill: "#090909",
    fontSize: 15,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SM Consulting Pte. Ltd."))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7934",
    "data-name": "Group 7934",
    transform: "translate(-488 5996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2567",
    "data-name": "Rectangle 2567",
    transform: "translate(812 374)",
    fill: "#fff",
    stroke: "#dae2d6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 391,
    height: 50,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 390,
    height: 49,
    rx: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Account_holder_address_",
    "data-name": "Account holder address ",
    transform: "translate(812 359)",
    fill: "#111",
    fontSize: 15,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Account holder address ")), /*#__PURE__*/React.createElement("text", {
    id: "_111_North_Bridge_Road_Singapore_179098",
    "data-name": "111, North Bridge Road, Singapore 179098",
    transform: "translate(829 404)",
    fill: "#090909",
    fontSize: 15,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "111, North Bridge Road, Singapore 179098"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7935",
    "data-name": "Group 7935",
    transform: "translate(-804 6194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2566",
    "data-name": "Rectangle 2566",
    transform: "translate(1128 272)",
    fill: "#fff",
    stroke: "#dae2d6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 391,
    height: 50,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 390,
    height: 49,
    rx: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Account_number_IBAN_",
    "data-name": "Account number (IBAN)",
    transform: "translate(1128 257)",
    fill: "#111",
    fontSize: 15,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Account number (IBAN)")), /*#__PURE__*/React.createElement("text", {
    id: "_8332464570",
    "data-name": 8332464570,
    transform: "translate(1145 302)",
    fill: "#090909",
    fontSize: 15,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "8332464570"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14267",
    "data-name": "Group 14267",
    transform: "translate(324 6528)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -68.73, -404.6)",
    filter: "url(#Path_23614)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_23614-2",
    "data-name": "Path 23614",
    transform: "translate(70.28 404.6)",
    fill: "#e6f3ed"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 432.7070617675781 62.33835601806641 L 6.746118068695068 62.33835601806641 C 3.302006959915161 62.33835601806641 0.5000069737434387 59.39596557617188 0.5000069737434387 55.77924346923828 L 0.5000069737434387 7.941744804382324 C 0.5000069737434387 4.32502269744873 3.302006959915161 1.382633924484253 6.746118068695068 1.382633924484253 L 24.4538402557373 1.382633924484253 L 24.64278411865234 1.382633924484253 L 24.78450775146484 1.257689476013184 L 31.11978721618652 -4.327622413635254 L 37.20428466796875 1.251189470291138 L 37.34767532348633 1.382633924484253 L 37.54217529296875 1.382633924484253 L 432.7070617675781 1.382633924484253 C 436.1511840820312 1.382633924484253 438.953125 4.32502269744873 438.953125 7.941744804382324 L 438.953125 55.77924346923828 C 438.953125 59.39596557617188 436.1511840820312 62.33835601806641 432.7070617675781 62.33835601806641 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 31.11318969726562 -3.655269622802734 L 24.83172607421875 1.882633209228516 L 6.746063232421875 1.882633209228516 C 3.577667236328125 1.882633209228516 1 4.600746154785156 1 7.941745758056641 L 1 55.77924346923828 C 1 59.12024688720703 3.577667236328125 61.83835601806641 6.746063232421875 61.83835601806641 L 432.7070007324219 61.83835601806641 C 435.8753967285156 61.83835601806641 438.453125 59.12024688720703 438.453125 55.77924346923828 L 438.453125 7.941745758056641 C 438.453125 4.600746154785156 435.8753967285156 1.882633209228516 432.7070007324219 1.882633209228516 L 37.15310668945312 1.882633209228516 L 31.11318969726562 -3.655269622802734 M 31.12628173828125 -4.999977111816406 L 37.54217529296875 0.8826332092285156 L 432.7070007324219 0.8826332092285156 C 436.4327697753906 0.8826332092285156 439.453125 4.043079376220703 439.453125 7.941745758056641 L 439.453125 55.77924346923828 C 439.453125 59.67790985107422 436.4327697753906 62.83835601806641 432.7070007324219 62.83835601806641 L 6.746063232421875 62.83835601806641 C 3.020355224609375 62.83835601806641 0 59.67790985107422 0 55.77924346923828 L 0 7.941745758056641 C 0 4.043079376220703 3.020355224609375 0.8826332092285156 6.746063232421875 0.8826332092285156 L 24.45382690429688 0.8826332092285156 L 31.12628173828125 -4.999977111816406 Z",
    stroke: "none",
    fill: "#d7dfe6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8499",
    "data-name": "Group 8499",
    transform: "translate(20.657 12.657)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "This_account_is_on_PayStreet_Money_will_be_deposited_in_real_time.",
    "data-name": "This account is on PayStreet! Money will be deposited in real time.",
    transform: "translate(24.946 -1.657)",
    fill: "#111",
    fontSize: 15,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 16
  }, "This account is on PayStreet! Money will be "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 39
  }, "deposited in real time.")), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check-circle",
    "data-name": "Icon awesome-check-circle",
    d: "M19.8,10.181A9.619,9.619,0,1,1,10.181.563,9.619,9.619,0,0,1,19.8,10.181ZM9.069,15.274,16.2,8.138a.621.621,0,0,0,0-.878l-.878-.878a.621.621,0,0,0-.878,0L8.63,12.2,5.913,9.485a.621.621,0,0,0-.878,0l-.878.878a.621.621,0,0,0,0,.878l4.034,4.034a.621.621,0,0,0,.878,0Z",
    transform: "translate(-6.33 9.781)",
    fill: "#2bd06f"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork2);
export default __webpack_public_path__ + "static/media/network2.af78f564fb097fa2ea910f3364dd559d.svg";
export { ForwardRef as ReactComponent };